import { useMutation } from '@apollo/client';
import React, { useMemo } from 'react';
import Helmet from 'react-helmet';

import Form from 'components/lib/form/Form';
import { sensitiveClassProps } from 'components/lib/higherOrder/withSensitiveData';
import SettingsCard from 'components/lib/layouts/SettingsCard';
import Column from 'components/lib/ui/Column';
import FlexContainer from 'components/lib/ui/FlexContainer';
import LoadingSpinner from 'components/lib/ui/LoadingSpinner';
import { HouseholdSettingsInnerForm } from 'components/routes/settings/HouseholdSettingsInnerForm';

import { GET_MY_HOUSEHOLD, UPDATE_MY_HOUSEHOLD } from 'common/lib/graphQl/household';
import useQuery from 'common/lib/hooks/useQuery';
import useDemoHousehold from 'lib/hooks/useDemoHousehold';

import { DEFAULT_COUNTRY } from 'common/constants/onboarding/user';

const HouseholdSettings = () => {
  const { isDemoHousehold } = useDemoHousehold();
  const { data, refetch, isLoadingInitialData } = useQuery(GET_MY_HOUSEHOLD);
  const [updateMyHousehold] = useMutation(UPDATE_MY_HOUSEHOLD);

  const {
    name,
    address,
    city,
    state,
    zipCode,
    country = DEFAULT_COUNTRY,
  } = data?.myHousehold ?? {};
  const initialValues = useMemo(
    () => ({ name, address, city, state, zipCode, country }),
    [address, city, country, name, state, zipCode],
  );

  return (
    <Column md={9}>
      <SettingsCard title="Household" isDemo={isDemoHousehold}>
        <Helmet>
          <title>Household Settings</title>
        </Helmet>
        {isLoadingInitialData ? (
          <FlexContainer justifyCenter alignCenter padding="xlarge">
            <LoadingSpinner />
          </FlexContainer>
        ) : (
          <Form
            initialValues={initialValues}
            onSubmit={async (values) => {
              await updateMyHousehold({
                variables: {
                  input: values,
                },
              });
            }}
            onSubmitSuccess={() => {
              refetch();
            }}
            {...sensitiveClassProps}
          >
            <HouseholdSettingsInnerForm />
          </Form>
        )}
      </SettingsCard>
    </Column>
  );
};

export default HouseholdSettings;
